import { cos } from './cos'
import { courseware } from './courseware'
import { user } from './user'

export const api = {
  user,
  courseware,
  cos,
}
